import { useState, type ReactNode } from "react";

type Props = {
  title: string;
  description?: string;
  defaultOpen?: boolean;
  headerRight?: ReactNode;
  children: ReactNode;
};

export function ProposalFormatCollapsibleSection({
  title,
  description,
  defaultOpen = false,
  headerRight,
  children,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="rounded-2xl border border-gray-200 bg-white dark:border-zinc-700 dark:bg-zinc-900 overflow-hidden">
      <div className="flex items-start gap-2 px-3 py-2.5">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex min-w-0 flex-1 items-start justify-between gap-2 text-left hover:bg-gray-50/80 dark:hover:bg-zinc-800/40 rounded-lg -mx-1 px-1 py-0.5"
        >
          <div className="min-w-0">
            <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-zinc-400">
              {title}
            </h4>
            {description ? (
              <p className="text-[11px] text-gray-500 dark:text-zinc-400 mt-0.5">{description}</p>
            ) : null}
          </div>
          <span className="shrink-0 text-[10px] text-gray-400 dark:text-zinc-500 pt-0.5">
            {open ? "▲" : "▼"}
          </span>
        </button>
        {headerRight ? <div className="shrink-0 pt-0.5">{headerRight}</div> : null}
      </div>
      {open ? (
        <div className="border-t border-gray-100 dark:border-zinc-800 px-3 pb-3 pt-3 space-y-3">
          {children}
        </div>
      ) : null}
    </section>
  );
}
